import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@/contexts/AuthContext';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@kamalkari/ui';
import { User, Package, MapPin, LogOut } from 'lucide-react';

export const Route = createFileRoute('/account')({
  component: AccountPage,
});

function AccountPage() {
  const navigate = useNavigate();
  const { user, isAuthenticated, signOut } = useAuth();

  if (!isAuthenticated) {
    navigate({ to: '/auth/sign-in' });
    return null;
  }

  const handleSignOut = async () => {
    await signOut();
    navigate({ to: '/' });
  };

  return (
    <main className="container-page py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-serif text-warm-900 mb-8">My Account</h1>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-1">
            <Card>
              <CardContent className="pt-6">
                <div className="text-center">
                  <div className="w-20 h-20 bg-warm-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <User className="w-10 h-10 text-warm-600" />
                  </div>
                  <h2 className="font-medium text-warm-900">{user?.email || 'Guest'}</h2>
                  <p className="text-sm text-warm-500 mt-1">Member since 2024</p>
                </div>

                <div className="mt-6 space-y-2">
                  <Button variant="outline" className="w-full justify-start" onClick={handleSignOut}>
                    <LogOut className="w-4 h-4 mr-2" />
                    Sign Out
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="md:col-span-2 space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Package className="w-5 h-5" />
                  Recent Orders
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-warm-500 text-center py-8">
                  No orders yet. Start shopping to see your orders here.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MapPin className="w-5 h-5" />
                  Saved Addresses
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-warm-500 text-center py-8">
                  No saved addresses. Add an address during checkout.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </main>
  );
}
